import { axiosApplication, axiosInstance, axiosInstanceAms, axiosPayment } from "./axiosConfig";

export const Login = async (payload) => {
  return await axiosInstance.post("/api/v1/otp/send-otp", payload);
};

export const pyament = async (id) => {
  return await axiosApplication.post(`/isPaymentDone/${id}`);
};

// Post BK Pay Body
export const postPayloadBK = async (payload) => {
  return await axiosPayment.post(`/generateb64singnedPayment`, payload);
};

export const finalBgReUpload = async (payload) => {
  return await axiosPayment.post(`/reupload-bg-document/`, payload);
};


export const ZeroFeeBgUpload = async (payload) => {
  return await axiosPayment.post(`/bank-guarantee-upload/`, payload);
};